export const siteConfig = {
  name: '缅北黑料',
  fullName: '缅北黑料 · 反诈内幕档案库',
  tagline: '看清园区套路，远离跨境陷阱',
  intro:
    '我们把公开报道、亲历者讲述与办案通报中反复出现的跨境诈骗线索整理成可查证的档案，一次讲清缅北诈骗园区的运作方式、电诈窝点的招募套路与骗局的完整链条。',
  email: 'contact@mianbei-heiliao.example',
  workingHours: '周一至周日 09:00 - 21:00',
  responseTime: '线索核实通常在 2 个工作日内反馈',
  foundedYear: '2021',
};

export const mainNav = [
  { label: '首页', to: '/' },
  { label: '内幕档案', to: '/archives' },
  { label: '常见问题', to: '/faq' },
  { label: '关于我们', to: '/about' },
];

export const riskStats = [
  { value: '28+', label: '已整理曝光档案', desc: '覆盖园区、电诈、招聘与投资四类线索' },
  { value: '4', label: '核心骗局类型', desc: '高薪招聘 · 杀猪盘 · 虚假投资 · 跨境偷渡' },
  { value: '47', label: '平均被困天数', desc: '来自亲历者讲述的中间值参考' },
  { value: '9', label: '出国前必查项', desc: '一份可以逐条打勾的自检清单' },
];

export const safetyTips = [
  {
    icon: 'ri-alarm-warning-line',
    title: '先看合同，再谈机票',
    desc: '任何只强调"包吃包住包机票"、却回避劳动合同与工作签证的境外岗位，都应当直接放弃。',
  },
  {
    icon: 'ri-map-pin-user-line',
    title: '核实地址是否可查',
    desc: '把招聘方给出的工作地址放进地图搜索，若查不到正规写字楼、园区名称模糊，多半存在风险。',
  },
  {
    icon: 'ri-secure-payment-line',
    title: '拒绝先垫付任何费用',
    desc: '押金、保证金、培训费、签证加急费，只要对方要求你先转账，基本可以判定为骗局。',
  },
  {
    icon: 'ri-shield-user-line',
    title: '把行程告诉家人',
    desc: '出境前留下准确目的地、联系人信息和每日报平安的时间约定，这是失联后最重要的线索。',
  },
];

export const testimonials = [
  {
    name: '陈先生',
    role: '求职者家属',
    quote:
      '弟弟失联后，我们在这份档案里第一次看懂了"高薪招聘"的套路，按流程整理材料、联系使领馆，终于在两个月后把人接了回来。',
  },
  {
    name: '林同学',
    role: '高校反诈志愿者',
    quote: '把园区的运作方式讲清楚，比单纯喊"别上当"有用得多。我们社团的反诈宣讲，素材有一半来自这里。',
  },
  {
    name: '赵女士',
    role: '社区网格员',
    quote: '内容不夸张、不猎奇，家里人看得进去。转发到业主群以后，好几位居民主动来问自己接到的招聘是不是骗局。',
  },
];

export const contactChannels = [
  { icon: 'ri-mail-line', label: '线索投递邮箱', value: 'contact@mianbei-heiliao.example' },
  { icon: 'ri-time-line', label: '人工核查时段', value: '周一至周日 09:00 - 21:00' },
  { icon: 'ri-file-shield-2-line', label: '隐私说明', value: '线索一律匿名处理，不会公开提供者信息' },
];